import React, { Component } from 'react';
import LogoFullWhite from '../../assets/images/logo-white.png';

export default class Login extends Component {
    render() {
        const { children } = this.props;
        return (
            <div className="main-content">
                <div className="header bg-gradient-danger py-7 py-lg-8 pt-lg-9">
                    <div className="container">
                        <div className="header-body text-center mb-7">
                            <div className="row justify-content-center">
                                <div className="col-lg-5 col-md-6">
                                    <img alt="Logo Zapay" src={LogoFullWhite} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>    
                <div className="container mt--8 pb-5">
                    <div className="row justify-content-center">
                        <div className="col-lg-5 col-md-7">
                            {children}
                            <div className="mt-3 text-center">
                                <small className="text-light opacity-70">&copy; 2019 Zapay - Todos os direitos reservados.</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Layout/Login.js